import React, { useEffect, useState } from 'react';
import { Table, Button, Dialog, Form, Select, Input } from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import 'antd/dist/antd.css';

const ResidentBuilding = (props) => {
  //住戶棟別Table
  const residentBuilding = client.service('residentBuilding');

  const [buildingArr, setBuildingArr] = useState([]);
  const [building, setBuilding] = useState('');
  const [editBuildingIndex, setEditBuildingIndex] = useState('');
  const [buildingName, setBuildingName] = useState('');
  const [addBuildingDialog, setAddBuildingDialog] = useState(false);
  const [editBuildingDialog, setEditBuildingDialog] = useState(false);
  const Option = Select.Option;

  //postalHouseholdsBuilding
  async function funFind(para) {
    const result = await residentBuilding.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funCreate(obj) {
    await residentBuilding.create(obj);
  }
  async function funUpdate(id, obj) {
    await residentBuilding.update(id, obj);
  }
  async function funRemove(id) {
    await residentBuilding.remove(id);
  }

  function updatedTimeSort(a, b) {
    return a.updatedTime < b.updatedTime ? 1 : -1;
  }
  function serverDataUpdate() {
    funFind({}).then((result) => {
      setBuildingArr(result.sort(updatedTimeSort));
    });
  }
  useEffect(() => {
    serverDataUpdate();
  }, []);

  return (
    <>
      <Button
        onClick={() => {
          setAddBuildingDialog(true);
        }}
      >
        建立棟別
      </Button>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addBuildingDialog}
        onOk={() => {
          setBuilding(''), setBuildingName('');
          setAddBuildingDialog(false),
            funCreate({
              createdTime: new Date().toLocaleString(),
              building: building || buildingName,
              updatedTime: new Date().toLocaleString(),
            }).then(() => {
              serverDataUpdate();
            });
        }}
        onCancel={() => {
          setBuilding('');
          setBuildingName('');
          setAddBuildingDialog(false);
        }}
        onClose={() => {
          setBuilding('');
          setBuildingName('');
          setAddBuildingDialog(false);
        }}
      >
        <Form.Item label="自行輸入棟別名稱(值將顯示於棟別選單中)">
          <Input
            name="building"
            placeholder="請輸入棟別名稱"
            onChange={(value) => {
              // console.log('onChange', value);
              setBuildingName(`${value.toUpperCase()}棟`);
            }}
          />
        </Form.Item>

        <Form.Item label="棟別">
          <Select
            id="buildingName"
            value={building ? building : buildingName}
            onChange={(value) => {
              setBuilding(value);
            }}
            // defaultValue="請選擇棟別"
            aria-label="name is"
            // showSearch
            // hasClear
          >
            <Option value="A棟">A棟</Option>
            <Option value="B棟">B棟</Option>
            <Option value="C棟">C棟</Option>
            <Option
              value={buildingName ? buildingName : '自行輸入'}
              disabled={buildingName ? false : true}
            >
              {buildingName}
            </Option>
          </Select>
        </Form.Item>
      </Dialog>
      <Table dataSource={buildingArr}>
        <Table.Column title="建立時間" dataIndex="createdTime" width={100} />
        <Table.Column title="棟別" dataIndex="building" width={100} />
        <Table.Column title="更新時間" dataIndex="updatedTime" width={100} />
        <Table.Column
          title="操作"
          width={200}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            return (
              <div>
                <Button
                  type="normal"
                  onClick={() => {
                    setBuilding(buildingArr[index].building);
                    setEditBuildingIndex(index);
                    setEditBuildingDialog(true);
                  }}
                >
                  編輯
                </Button>
                <Dialog
                  hasMask
                  className={styles.dialog}
                  visible={editBuildingDialog}
                  onOk={() => {
                    setBuilding('');
                    setBuildingName('');
                    let item = buildingArr[editBuildingIndex];
                    item.building = building;
                    item.updatedTime = new Date().toLocaleString();
                    funUpdate(item._id, item).then(() => {
                      serverDataUpdate();
                      setEditBuildingDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setBuilding('');
                    setBuildingName('');
                    setEditBuildingDialog(false);
                  }}
                  onClose={() => {
                    setBuilding('');
                    setBuildingName('');
                    setEditBuildingDialog(false);
                  }}
                >
                  <Form.Item label="修改棟別名稱(值將顯示於棟別選單中)">
                    <Input
                      name="building"
                      placeholder="請輸入棟別名稱"
                      onChange={(value) => {
                        // console.log('onChange', value);
                        setBuildingName(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="棟別">
                    <Select
                      id="building"
                      value={building ? building : buildingName}
                      onChange={(value) => {
                        setBuilding(value);
                      }}
                      defaultValue="請選擇棟別"
                      aria-label="name is"
                      // showSearch
                      // hasClear
                    >
                      <Option value="A棟">A棟</Option>
                      <Option value="B棟">B棟</Option>
                      <Option value="C棟">C棟</Option>
                      <Option
                        value={buildingName ? buildingName : '自行輸入'}
                        disabled={buildingName ? false : true}
                      >
                        {buildingName}
                      </Option>
                    </Select>
                  </Form.Item>
                </Dialog>

                <Button
                  type="primary"
                  warning
                  onClick={() => {
                    funRemove(buildingArr[index]._id).then(() => {
                      serverDataUpdate();
                    });
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }}
        ></Table.Column>
      </Table>
    </>
  );
};

export default ResidentBuilding;
